@import 'styles/blaze/mixins';

.header {
  display: flex;
}

.chosenPriceContent {
  .info {
    border-radius: 10px;
    background: linear-gradient(270deg, rgba(182, 75, 248, 0.2) 0%, rgba(1, 121, 207, 0.2) 100%), var(--default-bg);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  display: flex;
  flex-direction: column;
  gap: 16px;
}

.planDescription {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.planPriceDescription {
  align-items: center;
  display: flex;
  gap: 4px;
}

.planFeatures {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .planFeature {
    display: flex;
    align-items: center;
    gap: 9px;
  }
}

.footerText {
  margin-right: 13px;
}

.cardOnFileContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cardOnFileLabel {
  @include xs-sohne-book;

  color: var(--dark-60);
  line-height: 137%;
  margin: 0;
}

.cardOnFile {
  background: var(--Light-100);
  border-radius: 6px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.03), 0px 2px 5px 0px rgba(0, 0, 0, 0.07);
  display: flex;
  padding: 15px;
  justify-content: space-between;
  align-items: center;

  p {
    margin: 0;
  }
}

.cardDetails {
  display: flex;
  gap: 15px;
}

.cardNumber {
  display: flex;
  gap: 6px;
}

.obscured {
  color: var(--dark-15);
}

.buttonContainer {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  width: calc(100% + 80px);
  margin-top: 35px;
  margin-left: -40px;
  border-top: 1px solid var(--dark-4);
  padding: 15px;
}

.rightButtonsContainer {
  align-items: center;
  display: flex;
  gap: 13px;
}

.modalContent {
  padding-bottom: 0 !important;
}
